<template>
  <b-container class="os-card">
    <h3 class="text-center mb-5">{{ $helpers.getMetaTitleText($route) }}</h3>
    <b-alert v-model="form.state.errors" variant="danger">{{ $t('signupOH.errors.general-code') }}</b-alert>
    <b-alert show variant="danger" v-if="form.state.submitted && form.state.unauthorized"><div v-html="submitError"></div></b-alert>
    <b-form @submit.stop.prevent="signUpCheck" v-if="!userRegistered">
      <b-row>
        <b-col sm="12" xl="6" class="px-3">
          <b-form-group v-if="!inOpenlegal() && !$store.getters['session/referralActiveByApiClient']">
            <b-form-input type="text" v-model="$v.form.companyCode.$model" :placeholder="$t('signupOH.registerCodeEnt')"
              @blur="checkCompanyCode" :state="companyCodeIsValid" @input="resetForm()" :readonly="readOnlyFields.code">
            </b-form-input>
            <b-form-text v-if="!inOpensalud360() && (!$v.form.companyCode.$model || companyCodeIsValid)">{{ $t('signupOH.justIndicatedByBusiness') }}</b-form-text>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="!inOpensalud360() || companyCodeIsValid == true">{{ $t('signupOH.errors.enterCode') }}</b-form-invalid-feedback>
          </b-form-group>

          <transition v-if="!inOpenlegal()" name="slide-fade">
            <b-form-group v-if="codeInfo.generic">
              <b-form-input type="text" v-model="$v.form.reservationNumber.$model"
                :placeholder="reservationNumberPlaceholder" :state="validateState('reservationNumber')"></b-form-input>
              <b-form-invalid-feedback>{{ reservationNumberErrorMsg }}</b-form-invalid-feedback>
            </b-form-group>
          </transition>

          <transition v-if="!inOpenlegal() && inOpensalud360()" name="slide-fade">
            <b-form-group v-if="employeeGroupFieldIsVisible">
              <base-select v-model="$v.form.employeeGroup.$model" :options="codeInfo.employeeGroup" valueProp="id"
                label="groupName" :placeholder="$t('signupOH.center-or-business-unit')"
                :state="form.trySubmit && form.employeeGroup != null" :errorMsg="$t('signupOH.errors.center-or-business-unit')">
                <!-- <b-form-invalid-feedback v-if="form.trySubmit" :state="form.employeeGroup == null" >{{ $t('signupOH.errors.center-or-business-unit') }}</b-form-invalid-feedback> -->
              </base-select>
            </b-form-group>
            <b-form-group v-if="employeeGroupFreeFieldIsVisible">
              <b-form-input v-model="$v.form.employeeLocation.$model"
                 :placeholder="$t('signupOH.employeeLocation')"
                :state="validateState('employeeLocation')" :errorMsg="$t('signupOH.errors.employeeLocation')">
              </b-form-input>
            </b-form-group>
          </transition>

          <transition v-if="!inOpenlegal() && inOpensalud360()" name="fade">
            <b-form-group v-if="employeeNumberFieldIsVisible">
            <b-form-input v-model="$v.form.employeeNumber.$model"
              :placeholder="$t('signupOH.internal-code')" @input="resetEmployeeNumberValidation(); resetForm()" @blur="$v.form.employeeNumber.$touch()" :state="employeeNumberState" :errorMsg="$t('signupOH.errors.required-employee-number')"
               ></b-form-input>
              <b-form-invalid-feedback v-if="employeeNumberIsValid===false" >{{ $t('signupOH.errors.employee-number') }}</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="$v.form.employeeNumber.$dirty && $v.form.employeeNumber.$invalid && employeeNumberIsValid !== false"
              >{{ $t('signupOH.errors.required-employee-number') }}</b-form-invalid-feedback>
            </b-form-group>
          </transition>

          <transition v-if="!inOpenlegal()" name="slide-fade">
            <b-row v-if="isTravelCompany">
              <b-col sm="12" xl="12">
                <base-datepicker v-model="$v.form.reservationFromDate.$model" value-as-date
                  :state="validateState('reservationFromDate')" :placeholder="$t('signupOH.checkin-date')"
                  :validator="$v.form.reservationFromDate"></base-datepicker>
              </b-col>
              <b-col sm="12" xl="12">
                <base-datepicker v-model="$v.form.reservationToDate.$model" value-as-date
                  :state="validateState('reservationToDate')" :placeholder="$t('signupOH.checkout-date')"
                  :validator="$v.form.reservationToDate" :parentValidators="$v.form"></base-datepicker>
              </b-col>
            </b-row>
          </transition>

          <b-form-group v-if="!form.companyCode || codeInfo.codeType != 2">
            <b-form-input type="text" v-model="$v.form.name.$model" :placeholder="$t('signupOH.registerName')"
              :state="validateState('name')" @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterName') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group v-if="form.companyCode && codeInfo.codeType === 2">
            <b-form-input type="text" v-model="$v.form.name.$model" :placeholder="$t('signupOH.registerNameCenterResidence')"
              :state="validateState('name')" @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterName') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-row v-if="!form.companyCode || codeInfo.codeType != 2">
            <b-col sm="12" xl="6" class="pr-md-1 pr-0">
              <b-form-group>
                <b-form-input type="text" v-model="$v.form.firstSurname.$model"
                  :placeholder="$t('signupOH.registerSurname1')" :state="validateState('firstSurname')"
                  @input="resetForm()"></b-form-input>
                <b-form-invalid-feedback>{{ $t('signupOH.errors.enterSurname1') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="12" xl="6" class="pl-md-1 pl-0">
              <b-form-group>
                <b-form-input type="text" v-model="$v.form.secondSurname.$model"
                  :placeholder="$t('signupOH.registerSurname2')" :state="validateState('secondSurname')"
                  @input="resetForm()"></b-form-input>
                <b-form-invalid-feedback>{{ $t('signupOH.errors.enterSurname2') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br v-if="$uiHelpers.isMobile">
          <b-form-group>
          <div v-if="!form.companyCode || codeInfo.codeType != 2" class="inline-input text-center">
            <span class="text-uppercase pr-4 d-inline-block genderText">{{ $t('signupOH.genderSex') }}</span>
            <radio-button-gender class="d-inline-block" v-model="$v.form.gender.$model" :state="validateState('gender')"
              :errorMsg="$t('signupOH.errors.enterSex')"></radio-button-gender>
          </div>
          </b-form-group>
          <div v-if="!form.companyCode || codeInfo.codeType != 2" class="inline-input text-center">
            <base-birthdate-input v-model="form.birthDate"></base-birthdate-input>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('birthDate')">{{ $t('signupOH.errors.enterBirthdate') }}</b-form-invalid-feedback>
          </div>

          <b-form-group>
            <base-select id="country" :searchable="true" v-model="$v.form.countryId.$model"
              :placeholder="$t('signupOH.country')" :options="form.selectedCountry.options" :state="validateState('countryId')"
              :label="$i18nHelpers.normalizeProp('name')" valueProp="idCountry" @change="reCallProvince"
              :errorMsg="$t('signupOH.errors.enterCountry')" :clearable="false"/>
            <!-- <base-select id="country" v-model="selectCountry.selected" :label="$i18nHelpers.normalizeProp('name')"
              :placeholder="$t('signupOH.country')" :options="selectCountry.options" valueProp="idCountry"></base-select> -->
          </b-form-group>

          <b-form-group>
            <base-select id="province" :searchable="true" v-model="$v.form.stateId.$model"
              :placeholder="$t('signupOH.registerYourProvince')" :state="validateState('stateId')" :options="form.selectProvince.options"
              :label="$i18nHelpers.normalizeProp('name')" valueProp="id"></base-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" xl="6" class="px-3">
          <div v-if="codeInfo.codeType != 2">
          <b-form-group v-if="form.countryId === 28">
            <b-form-input type="text" v-model="$v.form.nif.$model" :placeholder="$t('signupOH.registerNIF')"
              :state="validateState('nif')" @input="resetForm()"></b-form-input>
              <b-form-invalid-feedback v-if="form.trySubmit && dniregistered" :state="dniregistered != true">
              {{ $t('signupOH.errors.duplicatedNIF') }}</b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="form.trySubmit && dniregistered != true" :state="form.nif != null ? validateNIF(form.nif) : false">
              {{ $t('signupOH.errors.enterNIF') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="form.countryId === 42">
            <b-form-input type="text" v-model="$v.form.nif.$model" :placeholder="$t('signupOH.enterCURP')"
             @input="resetForm()"></b-form-input>
             <b-form-invalid-feedback v-if="form.trySubmit && dniregistered" :state="dniregistered != true">
              {{ $t('signupOH.errors.duplicatedNIF') }}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="form.trySubmit && dniregistered != true" :state="form.nif != null">
              {{ $t('signupOH.errors.enterCURP') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="form.countryId !== 42 && form.countryId !== 28">
            <b-form-input type="text" v-model="$v.form.nif.$model" :placeholder="$t('signupOH.enterId')"
             @input="resetForm()"></b-form-input>
             <b-form-invalid-feedback v-if="form.trySubmit && dniregistered" :state="dniregistered != true">
              {{ $t('signupOH.errors.duplicatedNIF') }}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="form.trySubmit && dniregistered != true" :state="form.nif != null">
              {{ $t('signupOH.errors.enterID') }}</b-form-invalid-feedback>
          </b-form-group>
          </div>
          <b-form-group>
            <b-form-input type="text" @blur="ivecoAndExtensionEmailForEmployeeNumberInputDisplay" v-model="$v.form.email.$model" :placeholder="$t('signupOH.registerEmail')"
              :state="validateState('email')" @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterEmail') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <b-form-input type="text" v-model="$v.form.emailConfirmation.$model"
              :placeholder="$t('signupOH.confirmEmail')" :state="validateState('emailConfirmation')"
              @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterConfirmEmail') }}</b-form-invalid-feedback>
          </b-form-group>


          <b-row class="align-items-center">
            <b-col sm="12" xl="5" class="pr-md-2 pr-0">
              <b-form-group>
                <base-select id="prefix" v-model="$v.form.prefixCountry.$model" :searchable="true"
                  :placeholder="$t('signupOH.registerPhonePrefix')" :options="form.selectPrefix.options" :state="validateState('prefixCountry')"
                  :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="phonePrefix" />
              </b-form-group>
            </b-col>
            <b-col sm="12" xl="7">
              <b-form-group>
                <b-form-input type="number" v-model="$v.form.phoneNumber.$model"
                  :placeholder="$t('signupOH.registerPhoneNumber')" :state="validateState('phoneNumber')"
                  @input="resetForm()"></b-form-input>
                <b-form-invalid-feedback v-if="form.trySubmit" :state="form.phoneNumber != null">
                  {{ $t('signupOH.errors.enterPhoneNumber') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <v-select id="lang" v-model="$v.form.selectedLangs.$model" multiple
              :getOptionLabel="option => $i18nHelpers.normalizeProp('name') === 'name.es' ? option.name.es : option.name.en "
              :placeholder="$t('signupOH.selectLanguageTxt')" :options="this.form.formSelectLang.options">
              <template #option="option">
                <slot name="option" :option="option">
                </slot>
              </template>
              <template #no-options>
                {{ $t('signupOH.no-options') }}
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
                    <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z"
                      transform="translate(12) rotate(90)" fill="#8a8a8a" />
                  </svg>
                </span>
              </template>
            </v-select>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('selectedLangs')">
              {{ $t('signupOH.errors.enterLang') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="!inOpensalud360()">
          <base-select id="discovery" :state="validateState('discoveryCheck')" v-model="form.discoveryCheck" :searchable="true" label="text" :placeholder="$t('signupOH.selectDiscovery')" :options="this.form.selectDiscovery.options"></base-select>
          <b-form-invalid-feedback v-if="form.trySubmit" :state="form.discoveryCheck != null">{{ $t('signupOH.errors.enterDiscoveryType') }}</b-form-invalid-feedback>
        </b-form-group>
          <base-checkbox v-model="form.termsAccepted">
            <span v-html="$t('signupOH.accept-terms-patient')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('termsAccepted')">{{ $t('signupOH.errors.termsAccepted') }}</b-form-invalid-feedback>
          </base-checkbox>
          <base-checkbox v-model="form.privacyAccepted">
            <span v-html="$t('signupOH.accept-privacy-patient')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('privacyAccepted')">{{ $t('signupOH.errors.privacyAccepted') }}</b-form-invalid-feedback>
          </base-checkbox>
          <b-row style="align-items: center;justify-content: center;padding-bottom:1rem; text-align: center;">
            <VueRecaptcha :sitekey="siteKey" :load-recaptcha-script="true" @verify="handleSuccess" @error="handleError" @expired="handleError">
            </VueRecaptcha>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="validateState('captcha')">
              {{ $t('signupOH.errors.captcha') }}</b-form-invalid-feedback>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-button type="button" variant="primary" style="width: 100%" @click="signUpCheck">
          {{ $t('signupOH.signup-submit') }}
        </b-button>
        <hr>
        <span>{{ $t('signUp.already-registered') }}, <a href="/inicio-sesion">{{ $t('sign-up-href') }}</a>.</span>
      </b-row>
      <b-modal v-model="visibleModalMessageInfo" title-class="title-modal" centered no-close-on-esc no-close-on-backdrop hide-header-close>
    <div class="text-center">
        <div style="margin-bottom:1rem" v-for="(translation, index) in codeInfo.infoMessages" :key="index">
        <h6 style="margin-bottom: 0rem !important;">{{ $i18nHelpers.normalize(translation) }}</h6>
     </div>
      <div style="margin-bottom:1rem">
      <h6>{{ $t('bnpMSG2') }}</h6>
      </div>
    </div>
    <template #modal-footer>
      <b-button :variant="okBtnVariant" @click="signUp()">
      {{ $t('signupOH.continue') }}
      </b-button>
      <b-button :variant="cancelBtnVariant" @click="builtInCancelBNP()">
       {{ $t('signupOH.cancel') }}
      </b-button>
    </template>
  </b-modal>
      <b-modal v-model="visibleModalBusiness" title-class="title-modal" centered no-close-on-esc no-close-on-backdrop hide-header-close>
    <div class="text-center">
      <div style="margin-bottom:1rem">
      <h6 style="margin-bottom: 0rem !important;">{{ $t('signupOH.modalBusiness') }} </h6>
      </div>
      <div style="margin-bottom:1rem">
      <h6>{{ $t('signupOH.modalBusiness2') }}</h6>
      </div>
    </div>
    <template #modal-footer>
      <b-button :variant="okBtnVariant" @click="builtInOkFnBusiness()">
      {{ $t('signupOH.continue') }}      
      </b-button>
      <b-button :variant="cancelBtnVariant" @click="builtInCancelFnBusiness()">
       {{ $t('signupOH.cancel') }}      
      </b-button>
    </template>
  </b-modal>
    </b-form>
    <!-- <base-dialog :value="showConfirmBNP" :okFn="() => { removePushNotifications(); showConfirmBNP = false; }" :cancelFn="() => { showConfirmBNP = false; }" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :content="$t('bnpMSG')"></base-dialog> -->

    <div id="account-confirmation" v-if="userRegistered">
      <p class="text-left" v-html="$t('signupOH.account-confirmation', { email: $v.form.email.$model })"></p>
    </div>
  </b-container>
</template>

<script>
import { BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormInput, BAlert, BContainer, BFormText, BModal } from 'bootstrap-vue'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import helpers from '@/helpers'
import { GET_TRAVEL_COMPANIES } from '@/constants/companiesLandingNames'
import { required, requiredIf, minLength, numeric, email, sameAs } from 'vuelidate/lib/validators'
import { phone, onlyTrue, afterToday, afterDate, onlyText } from '@/plugins/customValidators'
import RadioButtonGender from '../base/forms/RadioButtonGender.vue'
import BaseMultiSelect from '../base/forms/BaseMultiSelect.vue'
import BaseSelect from '../base/forms/BaseSelect.vue'
import { recaptcha } from '@/constants/recaptcha'
import { VueRecaptcha } from 'vue-recaptcha'
import CompaniesRepository from '@/repositories/CompaniesRepository'
import BaseBirthdateInput from '@/components/base/forms/BaseBirthdateInput'
import { BARCELO_SUBDOMAIN, IBEROSTAR_SUBDOMAIN, WAMOS_SUBDOMAIN, ASSEGUR_SUBDOMAIN, NAUTALIA_SUBDOMAIN, CARREFOUR_SUBDOMAIN, MSM_SUBDOMAIN } from '@/constants/subdomains'
import geographyRepository from '@/repositories/GeographyRepository'
import languagesRepository from '@/repositories/LanguageRepository'
import { inOpensalud360, inOpenlegal } from '@/constants/platformNames'
import { validationsMixin } from '@/mixins/validations.mixin'
import { EDUCATIVE_CENTER_CODE_TYPE } from '@/constants/db/companyCodeTypes'
import { getDefaultCountryId, getDefaultPhonePrefix, inMx } from '@/helpers/global.helpers'
import { getOAuthRequiredCompanyCodeByAction } from '../../constants/loginAdditionalActions'

// Get subdomain from current url
const SUBDOMAIN = helpers.getSubdomain()

export default {
  name: 'patient-sign-up-form',
  mixins: [validationsMixin],
  components: {
    BForm,
    BModal,
    BFormGroup,
    BButton,
    BFormInvalidFeedback,
    BFormInput,
    BAlert,
    BContainer,
    'base-select': BaseSelect,
    'base-multiSelect': BaseMultiSelect,
    'radio-button-gender': RadioButtonGender,
    BaseCheckbox,
    BaseDatepicker,
    VueRecaptcha,
    BaseBirthdateInput,
    BFormText
  },
  props: {
    callback: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
			inOpenlegal,
			inOpensalud360,
      inMx,
      siteKey: recaptcha,
      visibleModalBusiness: false,
      visibleModalMessageInfo: false,
      dniregistered: false,
      form: {
      selectedCountry: {
        options: []
      },
        captcha: false,
        email: this.$route.query.email,
        emailConfirmation: null,
        name: this.$route.query.name,
        firstSurname: this.$route.query.firstSurname,
        secondSurname: this.$route.query.secondSurname,
        gender: null,
        countryId: this.$route.query.countryId,
        stateId: null,
        prefixList: [],
        prefix: null,
        csrfToken: null,
        birthDate: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        },
        companyCode: this.$route.query.code,
        nif: null,
        phoneNumber: null,
        prefixCountry: null,
        selectedLangs: null,
        reservationNumber: null,
        employeeGroup: null,
        reservationFromDate: null,
        reservationToDate: null,
        employeeNumber: this.$route.query.employeeNumber,
        employeeLocation: null,
        discoveryCheck: null,
        termsAccepted: false,
        privacyAccepted: false,
      formSelectLang: {
        options: []
      },
      selectDiscovery: {
        options: [
        { value: '1', text: inOpenlegal() ? this.$t('signupDiscovery.title1-openlegal') : this.$t('signupDiscovery.title1') },
          { value: '2', text: inOpenlegal() ? this.$t('signupDiscovery.title2-openlegal') : this.$t('signupDiscovery.title2') },
          { value: '3', text: inOpenlegal() ? this.$t('signupDiscovery.title3-openlegal') : this.$t('signupDiscovery.title3') },
          { value: '4', text: this.$t('signupDiscovery.title4') },
          { value: '5', text: this.$t('signupDiscovery.title5') },
          { value: '6', text: 'Email' },
          { value: '7', text: this.$t('signupDiscovery.title7') },
          { value: '8', text: this.$t('signupDiscovery.title8') },
          { value: '9', text: this.$t('signupDiscovery.title9') },
          { value: '10', text: this.$t('signupDiscovery.title10') },
          { value: '11', text: this.$t('signupDiscovery.title11') }
        ]
      },
      selectProvince: {
        options: []
      },
      selectPrefix: {
        options: []
      }
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null,
      companyCodeIsValid: null,
      employeeNumberIsValid: null,
      codeInfo: { },
      userRegistered: false,
			readOnlyFields: {
				code: false
			}
    }
  },
  validations: {
    form: {
      name: {
        required,
        onlyText,
        validateName () {
          return (!!this.form.name && this.form.name !== '' && this.validateText(this.form.name))
        }
      },
      firstSurname: {
      onlyText,
      requiredIfNotEducativeCenter () {
          return (this.form.firstSurname != null || (this.codeInfo && this.codeInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE))
      },
      validateFirstSurname () {
        return ((this.form.firstSurname != null && this.form.firstSurname !== '' && this.validateText(this.form.firstSurname)) || (this.codeInfo && this.codeInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE))
      }
      },
      secondSurname: {
        onlyText,
        validateSecondSurname () {
          return (this.form.secondSurname === null || this.form.secondSurname === '' || this.validateText(this.form.secondSurname))
        }
      },
      email: {
        required,
        email,
        validateEmail () {
          return (!!this.form.email && this.form.email !== '')
        }
      },
      emailConfirmation: {
        required,
        email,
        sameAsEmail: sameAs('email'),
        validateEmailConfirmation () {
          return (this.form.emailConfirmation != null && !!this.form.emailConfirmation)
        }
      },
      gender: {
        validateGender () {
          return (this.form.gender != null || (this.codeInfo && this.codeInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE))
        }
      },
      countryId: {
        required,
        numeric,
        validateCountry () {
          return (this.form.countryId != null && this.form.countryId !== '')
        }
      },
      stateId: {
        required,
        numeric,
        validateState () {
          return (this.form.stateId != null && this.form.stateId !== '')
        }
      },
      birthDate: {
        validateBirthdate () {
          return (this.codeInfo.codeType === 2 || this.form.birthDate != null)
        }
      },
      discoveryCheck: {
        required: requiredIf(function () {
        return !this.in360
      })
      },
      selectedLangs: {
        required,
        minLength: minLength(1)
      },
      companyCode: {
        required: requiredIf(function () {
        return this.in360
      }),
      validateCompanyCode () {
        return (!this.in360 || (!!this.form.companyCode && (!this.employeeGroupFieldIsVisible || !!this.form.employeeGroup) && (!this.employeeGroupFreeFieldIsVisible || !!this.form.employeeLocation) && (!this.employeeNumberFieldIsVisible || !!this.form.employeeNumber)))
      }
      },
      reservationNumber: {
        required: requiredIf(() => {
          return this.in360 && !this.codeIsGeneric
        })
      },
      employeeGroup: {
        validate () {
        return !this.in360 || (this.in360 && this.employeeGroupFieldIsVisible && this.form.employeeGroup != null) || (this.in360 && !this.employeeGroupFieldIsVisible)
      },
        numeric
      },
      employeeLocation: {
        required: requiredIf(() => {
          return this.in360 && !this.employeeGroupFreeFieldIsVisible
        })
      },
      reservationFromDate: {
        required: requiredIf(() => {
          return this.in360 && !this.isTravelCompany
        })
      },
      reservationToDate: {
        required: requiredIf(() => {
          return this.in360 && !this.isTravelCompany
        }),
        afterToday () {
          return requiredIf(() => this.in360 && !this.isTravelCompany)
          ? afterToday
        : true
        },
        afterDate () {
          return requiredIf(() => this.in360 && !this.isTravelCompany)
          ? afterDate('reservationFromDate') : true
        }
      },
      employeeNumber: {
        required: requiredIf(function () {
        return this.in360 && this.employeeNumberFieldIsVisible
      })
      },
      nif: {
      validate () {
        return inMx || this.form.nif != null || this.codeInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE
      },
        validateNIF () {
          return this.$validators.validatePersonalId(this.form.nif, this.form.countryId, this.codeInfo.codeType)
        },
        validateNIFRegistered () {
          return this.dniregistered !== true
        }
      },
      prefixCountry: {
        required
      },
      phoneNumber: {
        required,
        phone
      },
      termsAccepted: {
        required,
        onlyTrue
      },
      captcha: {
        required,
        onlyTrue
      },
      privacyAccepted: {
        required,
        onlyTrue
      }
    }
  },
  methods: {
    builtInOkFnBusiness () {
      this.visibleModalBusiness = false
			// Add all the params to the url
      window.location = this.$helpers.get360AppUrl('registro-paciente', this.$route.query)
    },
    builtInCancelFnBusiness () {
      this.form.companyCode = null
      window.location.reload()
      this.visibleModalBusiness = false
    },
    validateNIF (dni) {
			return this.$validators.validatePersonalId(dni, this.form.countryId, this.codeInfo.codeType)
    },
    validateText: function (text) {
            var re = /^[A-Za-zÀ-ÖØ-öø-ÿ\- ]+$/i
            if (!re.test(text)) {
                return false
            } else {
                return true
            }
    },
    builtInCancelBNP () {
      this.visibleModalMessageInfo = false
    },
    reCallProvince: function () {
      this.form.stateId = null
      geographyRepository.getStatesByCountry(this.form.countryId).then((response) => {
				this.form.selectProvince.options = response.data
			})
    },
    handleError: function () {
      this.form.captcha = false
      },
    handleSuccess: function () {
      this.form.captcha = true
    },
      signUpCheck: function () {
        if (this.form.companyCode != null && (this.codeInfo.infoMessages && this.codeInfo.infoMessages.length > 0)) {
          this.visibleModalMessageInfo = this.formIsValid()
        } else {
          this.signUp()
        }
      },
     signUp: function () {
      const _this = this
      this.$v.form.$touch()
      this.form.trySubmit = true
      var maleRole = false
      this.form.state.submitted = true
      this.dniregistered = false
      this.form.state.waiting = true
      if (this.form.gender === 'H') maleRole = true
      /* this.resetForm()
      this.form.state.submitted = true */
      if (this.formIsValid()) {
        var lng = []
      this.form.selectedLangs.map((x, i) => {
        lng.push(x.id)
      })
        this.$api.post('/webapp/patients', {
          ClientReturnUrl: encodeURIComponent(_this.$route.query.returnUrl || (_this.$route.query.ReturnUrl || null)),
          role: 'Paciente',
          codPromotion: this.form.companyCode != null ? this.form.companyCode.trim() : null,
          firstName: this.form.name.trim(),
          lastName1: this.codeInfo.codeType === 2 ? null : this.form.firstSurname.trim(),
          lastName2: this.codeInfo.codeType === 2 ? null : this.form.secondSurname != null ? this.form.secondSurname.trim() : null,
          male: this.codeInfo.codeType === 2 ? false : maleRole,
          female: this.codeInfo.codeType === 2 ? false : !maleRole,
          idHowToMeet: this.form.discoveryCheck != null ? this.form.discoveryCheck : 10,
          idCountry: this.form.countryId,
          idProvince: this.form.stateId,
          languages: lng,
          prefix: this.form.prefixCountry,
          phone: this.form.phoneNumber,
          dni: this.form.nif,
          email: this.form.email.toLowerCase(),
          bornDate: this.codeInfo.codeType === 2 ? null : this.form.birthDate,
          reservationNumber: this.form.reservationNumber,
          employeeGroup: this.form.employeeGroup,
          reservationFromDate: this.form.reservationFromDate,
          reservationToDate: this.form.reservationToDate,
          employeeNumber: this.form.employeeNumber,
          employeeLocation: this.form.employeeLocation
        }).then((response) => {
          let res = response
          if (!response.data) {
            res = response.response
          }
          this.defaultLoginCallback(res)
        }).catch((error) => {
          if (error) {
            this.form.state.errors = true
            this.form.state.waiting = false
          }
        })
      } else {
        this.builtInCancelBNP()
        this.form.state.waiting = false
      }
    },
    defaultLoginCallback (response) {
      if (response.data) {
        switch (response.data.status) {
          case 200:
            if (response.data.data === 'business') {
             this.visibleModalBusiness = true
						} else if (response.data.data && this.form.companyCode && getOAuthRequiredCompanyCodeByAction(response.data.data)) {
							this.$router.push({ path: '/inicio-sesion', query: { code: this.form.companyCode } })
            } else {
              return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: true } })
            }
            break
          case 403:
            this.submitError = response.data.message
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 502:
            this.submitError = this.$t('error-short')
            this.employeeNumberIsValid = false
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
            case 503:
            this.submitError = this.$t('error-alreadyregister')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          default:
            this.form.state.errors = true
            this.form.state.waiting = false
            break
        }
      } else {
        this.form.state.errors = true
        this.form.state.waiting = false
      }
    },
     validateEmail (email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },
    touchFields (fields, nameInput) {
      fields.forEach(field => {
        if (this.$route.query[field]) {
          this.$v.form[nameInput].$touch()
        }
      })
    },
    ivecoAndExtensionEmailForEmployeeNumberInputDisplay () {
      if (this.codeInfo.isIveco) {
        if (this.form.email === '' || this.form.email === null || this.form.email === undefined || !this.validateEmail(this.form.email)) return false
        var emailLowerCase = this.form.email.toLowerCase()
        for (let extension of this.codeInfo.emailExtensions) {
          if (emailLowerCase.includes(extension.toLowerCase())) {
              return false
          }
      }
      return true
      }
      return true
    },
    async checkCompanyCode () {
      let code = null
      if (!this.$v.form.companyCode.$model) {
         this.companyCodeIsValid = null
         return
      }
      await CompaniesRepository.getCode(this.$v.form.companyCode.$model).then((response) => {
        code = response.data
        this.codeInfo = code
        const clientNumberInfoDialogMsg = this.$te(`signupOH.info.reservationNumber.${this.$v.form.companyCode.$model}`)
        if (clientNumberInfoDialogMsg) {
          this.$store.dispatch('showSharedDialog', { content: this.$t(`signupOH.info.reservationNumber.${this.$v.form.companyCode.$model}`) })
        }
      })
      if (code && !this.in360) {
        this.visibleModalBusiness = true
      }
      this.companyCodeIsValid = !!code
    },
    resetForm () {
      this.form.state.submitted = false
      this.form.state.waiting = false
      this.form.state.unauthorized = false
      this.form.state.errors = false
    },
    resetEmployeeNumberValidation () {
      this.employeeNumberIsValid = true
  }
},
  computed: {
    emailValidation: function () {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted)
    },
    emailMatches () {
      return this.form.state.submitted ? this.form.email === this.form.emailConfirmation : null
    },
    passwordValidation: function () {
      return this.$validators.validate(this.form.password, ['required', 'password'], this.form.state.submitted)
    },
    requiredValidation () {
      return prop => {
        return this.$validators.validate(prop, ['required'], this.form.state.submitted)
      }
    },
    nifIsValid () {
      return this.$validators.validate(this.form.nif, ['required'], this.form.state.submitted)
    },
    phoneNumberIsValid () {
      return this.$validators.validate(this.form.phoneNumber, ['required', 'phone'], this.form.state.submitted)
    },
    companyCodePlaceholder () {
      switch (SUBDOMAIN) {
        case BARCELO_SUBDOMAIN:
        case IBEROSTAR_SUBDOMAIN:
          return this.$t('signupOH.reservation-number-or-code')
        case WAMOS_SUBDOMAIN:
        case ASSEGUR_SUBDOMAIN:
          return this.$t('signupOH.certificate-number-or-code')
        case NAUTALIA_SUBDOMAIN:
        case CARREFOUR_SUBDOMAIN:
          return this.$t('signupOH.generic-code')
        case MSM_SUBDOMAIN:
          return this.$t('signupOH.code-provided-by-msm')
        default:
          return this.$t('signupOH.code-provided-by-company-or-entity')
      }
    },
    reservationNumberPlaceholder () {
      switch (SUBDOMAIN) {
        case BARCELO_SUBDOMAIN:
        case IBEROSTAR_SUBDOMAIN:
          return this.$t('signupOH.reservation-number')
        case WAMOS_SUBDOMAIN:
        case ASSEGUR_SUBDOMAIN:
        case NAUTALIA_SUBDOMAIN:
        case CARREFOUR_SUBDOMAIN:
          return this.$t('signupOH.certificate-number')
        case MSM_SUBDOMAIN:
          return this.$t('signupOH.client-number')
        default:
          return this.$t('signupOH.client-number')
      }
    },
    reservationNumberErrorMsg () {
      switch (SUBDOMAIN) {
        case BARCELO_SUBDOMAIN:
        case IBEROSTAR_SUBDOMAIN:
          return this.$t('signupOH.errors.reservation-number')
        case WAMOS_SUBDOMAIN:
        case ASSEGUR_SUBDOMAIN:
        case NAUTALIA_SUBDOMAIN:
        case CARREFOUR_SUBDOMAIN:
          return this.$t('signupOH.errors.certificate-number')
        case MSM_SUBDOMAIN:
          return this.$t('signupOH.errors.client-number')
        default:
          return this.$t('signupOH.errors.client-number')
      }
    },
    requiredOnlyInTravelValidation () {
      return prop => {
        return this.isTravelCompany ? this.$validators.validate(prop, ['required'], this.form.state.submitted) : true
      }
    },
    requiredOnlyInGenericCodesValidation () {
      return prop => {
        return this.codeInfo.generic ? this.$validators.validate(prop, ['required'], this.form.state.submitted) : true
      }
    },
    getCompanyCodeInputState () {
      return !this.form.state.submitted ? this.companyCodeIsValid : (this.requiredValidation(this.form.companyCode) && this.companyCodeIsValid)
    },
    getTermsFormState () {
      return !this.form.state.submitted ? this.termsAccepted : this.termsAccepted === true
    },
    isTravelCompany () {
      return GET_TRAVEL_COMPANIES().includes(SUBDOMAIN)
    },
    employeeGroupFieldIsVisible () {
      return this.codeInfo.employeeGroup && this.codeInfo.employeeGroup.length > 0 && this.codeInfo.employeeGroup.every(group => !group.createdByPatient)
    },
    employeeGroupFreeFieldIsVisible () {
      return this.codeInfo.employeeGroup && (this.codeInfo.employeeGroup.length > 0 && this.codeInfo.employeeGroup.every(group => group.createdByPatient))
    },
    employeeLocationFieldIsVisible () {
      return this.codeInfo.employeeGroup
    },
    employeeNumberFieldIsVisible () {
      return this.codeInfo.employeeNumberRequired && this.ivecoAndExtensionEmailForEmployeeNumberInputDisplay()
    },
    codeIsGeneric () {
      return this.codeInfo.generic
    },
    in360 () {
      return inOpensalud360()
    },
    employeeNumberState () {
    if (this.employeeNumberIsValid === false) {
      return false
    }
    if (this.$v.form.employeeNumber.$dirty && this.$v.form.employeeNumber.$invalid) {
      return false
    }
    if (this.$v.form.employeeNumber.$dirty && !this.$v.form.employeeNumber.$invalid) {
      return true
    }
    return null
  }
  },
  async mounted () {
      languagesRepository.getLanguages().then((response) => {
      this.form.formSelectLang.options = response.data
    })
    await geographyRepository.getCountries().then((response) => {
      this.form.selectedCountry.options = response.data
      this.form.selectPrefix.options = response.data
      // console.log(this.$i18nHelpers.getNormalizedLocale())
      // console.log(this.prefixCountry)
      this.form.countryId = getDefaultCountryId()
      this.form.prefixCountry = getDefaultPhonePrefix()
/*       const selectedCountry = this.form.selectedCountry.options.find(country => !this.inMx ? country.idCountry === SPAIN_COUNTRY_ID : country.idCountry === MX_COUNTRY_ID) */
      /* this.form.countryId = selectedCountry.idCountry */
			geographyRepository.getStatesByCountry(this.form.countryId).then((response) => {
				this.form.selectProvince.options = response.data
			})
    })

		// Check for available api client token and company code in peristed $store
		if (this.$store.getters['session/referralActiveByApiClient']) {
			this.form.companyCode = this.$store.state.session.user.companyCode.code
		}
		if (this.$route.query.code) {
			this.checkCompanyCode()
			this.touchFields(['code'], 'companyCode')
			this.readOnlyFields['code'] = true
		}

		// touch all fields that appear in the url query string
		const fieldsToTouch = [
		{ name: 'email', query: 'email' },
		{ name: 'name', query: 'name' },
		{ name: 'firstSurname', query: 'firstSurname' },
		{ name: 'secondSurname', query: 'secondSurname' },
		{ name: 'nif', query: 'nif' }
		]
		fieldsToTouch.forEach(field => {
			if (this.$route.query[field.query]) {
				this.$v.form[field.name].$touch()
			}
		})
  }
}
</script>

<style lang="scss" scoped>
  span .vs__selected{
    margin-left: 1%;
    font-size: 0.8rem;    
  }

  .v-select {
    // margin: 2% 0px 2% 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;

  }
  .vs__selected{
  margin-left: 1rem !important;
  padding: 0 0.8em !important;
  }

  div .v-select .vs--unsearchable{
    margin: 0px !important;
  }

  .vs__selected, .vs__search, .vs__search:focus {
  margin-left: 1rem !important;
  
  }

  .v-select .vs--single .vs--unsearchable{
        margin: 0px !important;
  }

  div .mt-3, button, p, fieldset, .v-select, .custom-checkbox, .my-3 {
      margin-top: 0rem !important;
  }

  #lang{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #prefix{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #country{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #province{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }

  #genderForm{
    // display: inline-flex;
    text-align: left !important;
  }

  .genderText{
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    padding: 0rem 2.2rem;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    // margin-right: auto !important;
    // margin-left: auto !important;
  }

  @media (max-width: 1024px) {
    .Body1_OH-sm{
    display:block !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    }
  }



  .headerMenu {
    margin: 22px 133px 0px 4% ;
    // line-height: 2.70 !important;
    // display: block !important;
    // @media (max-width: 1024px) {
    //   margin: auto !important;
    // }
  }

  div  .Body3_rightCol{
      padding-right: 0px !important;
      padding-left: 0px !important;      
  }

  .Body2_OH {
    margin: 5% 0% 0% 12% !important;
}
.Body3_div {
    display: block;
    padding: 8% 0px 8% 10% !important;;
    background-color: #1D1D1E;
    opacity: 87%;
    margin: 0px 0% 0px 0px !important;
}

.os-card {
  @include desktop {
    padding: 3rem 6rem;
  }
  @include desktop-sm {
    padding: 3rem 6rem;
  }
  @include tablets {
    padding: 3rem 6rem;
  }
  @include mobile {
    padding: 3rem 1rem;
    h3{
      font-size: 1.3rem;
    }
  }
  border-radius: $border-radius !important;
  box-shadow: $custom-shadow;
  margin: {
    bottom: 2rem;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/forms/PatientSignupForm.vue